export const DEFAULT_STAR_COLOR = 'var(--accent)';
export const DEFAULT_PROGRESS_BAR_COLOR = 'var(--accent)';
export const DEFAULT_PROGRESS_BAR_BG_COLOR = 'color-mix(in srgb, var(--text-light) 30%, transparent)';
export const DEFAULT_TEXT_COLOR = 'var(--text)';
export const DEFAULT_SECONDARY_TEXT_COLOR = 'var(--text-light)';
